import { Input, Table } from 'antd';

function Page3({ data, reviewer }) {
	const columns = [
		{
			title: 'Version',
			dataIndex: 'version',
			key: 'version',
			width: '15%',
			className: 'font-bold',
		},
		{
			title: 'Author',
			dataIndex: 'author',
			key: 'author',
			width: '25%',
		},
		{
			title: 'Date',
			dataIndex: 'date',
			key: 'date',
			width: '20%',
		},
		{
			title: 'Change',
			dataIndex: 'change',
			key: 'change',
			width: '40%',
		},
	];

	return (
		<div className="bg-white">
			{/* Secondary Signature Section */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-2">
					Secondary Signature (Compliance)
				</h2>
				<p className="text-xs text-gray-700 mb-4">
					(Secondary signature is only required when{' '}
					<span className="font-semibold">multiple roles</span> are requested
					for the user)
				</p>

				{/* Reviewer Details Table */}
				<div className="border-2 border-black mb-4">
					{/* Reviewer Name */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">REVIEWER NAME</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Reviewer Email */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">REVIEWER EMAIL ID</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Reviewer WWID */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">REVIEWER WWID</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Reviewer Contact Number */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">REVIEWER CONTACT NUMBER</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Reviewer Signature */}
					<div className="grid grid-cols-2">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">REVIEWER SIGNATURE</span>
						</div>
						<div className="p-0">
							{reviewer?.image && (
								<img
									src={reviewer?.image}
									alt="Reviewer Signature"
									style={{ width: '300px', height: '180px' }}
								/>
							)}
							<div className="pl-5">
								<span className="font-bold">Timestamp:</span>
								{reviewer.timestamp}
							</div>
							<div className="pl-5 mb-5">
								<span className="font-bold">Name:</span>
								{reviewer.name}
							</div>
						</div>
					</div>
				</div>

				{/* Reviewer Note */}
				<div className="bg-gray-100 border-2 border-black p-3">
					<p className="text-xs text-black m-0">
						<span className="font-semibold">Note:</span> Review multiple roles
						for conflict and controls in place.
					</p>
				</div>
			</div>
			{/* Form Version Control Section */}
			<div className="mb-8">
				<h2 className="text-sm font-bold mb-4">Form Version Control</h2>

				<Table
					columns={columns}
					dataSource={data}
					pagination={false}
					bordered
					size="middle"
					className="version-control-table"
				/>
			</div>

			{/* End of Form Divider */}
			<div className="border-t-2 border-dashed border-gray-400 pt-4 text-center">
				<span className="text-sm font-bold text-gray-600">END OF FORM</span>
			</div>
		</div>
	);
}

export default Page3;
